import { h, createRef } from "preact";
import { useEffect } from "preact/hooks";
import { classNames } from "../helpers";

export default function Overlay({ children, onClick, onClose, transparent }) {
  const ref = createRef();

  function handleClick() {
    onClick && onClick();
  }

  useEffect(() => {
    return () => {
      onClose && onClose();
    };
  }, []);

  return (
    <div
      class={classNames("overlay", transparent && "overlay--transparent")}
      ref={ref}
    >
      <div class="overlay__clickTarget" onClick={handleClick}></div>
      {children}
    </div>
  );
}
